React = require 'react'
t = require('views/internal/recup-with-helpers')('bulk_add_org_members')
_ = require 'underscore'
ApiError = require 'network/api-error'
ApiPromise = require 'network/api-promise'
PopOver = require 'views/lib/pop-over'
Promise = require 'bluebird'
track = require 'debug/track'
Summary = require './manage-org-members-component/summary'

emailRegex = /^[^@]+@[a-z0-9-]+(\.[a-z0-9-]+)+$/i
usernameRegex = /^@[a-z0-9_]{3,}$/

module.exports = class BulkAddOrgMembersView extends React.Component

  constructor: (props) ->
    super

    @state =
      addingMembers: false
      addedMembers: false
      progressText: ''
      enterpriseName: props.model.getEnterprise()?.get('displayName') ? ''
      entry: ''
      results: []

    @onInputChanged = @onInputChanged.bind(@)
    @onClose = @onClose.bind(@)
    @addMembers = @addMembers.bind(@)
    @_parseEntries = @_parseEntries.bind(@)
    @_parseEmails = @_parseEmails.bind(@)
    @_parseUsernames = @_parseUsernames.bind(@)

  _parseEntries: ->
    @state.entry.split(/[\s,;"<>]/)

  _parseEmails: ->
    _.chain(@_parseEntries())
    .map (email) ->
      email.replace(/^\s+|\s+$/g, '').toLowerCase()
    .filter (email) -> emailRegex.test(email)
    .uniq()
    .sort()
    .value()

  _parseUsernames: ->
    _.chain(@_parseEntries())
    .map (username) ->
      username.replace(/^\s+|\s+$/g, '').toLowerCase()
    .filter (username) -> usernameRegex.test(username)
    .map (username) ->
      username.replace(/@/g, '')
    .uniq()
    .sort()
    .value()

  onClose: ->
    PopOver.hide()

  onInputChanged: (e) ->
    @setState { entry: e.target.value }

  addMembers: (e) ->
    { model } = @props
    @setState { addingMembers: true }

    users = [
      @_parseEmails()...
      @_parseUsernames()...
    ]

    track("Organization View", "Members Page", "Bulk Add", users.length)

    model.addMembers(users, { ignoreErrors: true }, (progress) =>
      @setState { progressText: "#{ progress.completed }/#{ progress.length }" })
    .then (grouped) =>
      @setState { addingMembers: false, addedMembers: true, results: grouped }

      for category, entries of grouped
        track("Organization View", "Members Page", "Bulk Add", category, users.length)
    .done()

  render: t.renderable ->
    { model } = @props
    { addingMembers, addedMembers, progressText, results, enterpriseName, entry } = @state

    if addingMembers
      t.div ->
        t.div '.spinner.loading'
        t.div '.org-members-bulk-add-progress', ->
          t.text progressText

    else if addedMembers
      t.div =>
        results._categoryOrder
          .filter((category) -> results[category]?.length > 0)
          .map((category) ->
            t.div '.org-members-bulk-add-results-heading', ->
              t.format ['category', category], { enterpriseDisplayName: enterpriseName }
              t.text ' ('
              t.text results[category].length
              t.text ')'
            t.div '.org-members-bulk-add-results-list', ->
              for entry in results[category]
                t.div '.org-members-bulk-add-results-list-item', ->
                  t.text entry
          )

        t.div =>
          t.button '.primary.full', { onClick: @onClose }, ->
            t.format 'done'

    else
      emailCount = @_parseEmails().length
      usernameCount = @_parseUsernames().length
      count = emailCount + usernameCount
      showBillingSummary = model.isBusinessClass() && !model.isPO()

      t.div '.add-member-popup', =>
        t.label =>
          t.format 'emails-or-usernames'
          t.textarea '.org-members-bulk-add', { placeholder: t.l('list-placeholder'), onChange: @onInputChanged, value: entry }

        t.div { class: t.classify('org-members-bulk-add-found': true, 'quiet': true, 'bottom-padding': showBillingSummary) }, ->
          if emailCount > 0
            t.div '.org-members-bulk-add-found-entry', ->
              t.format 'email-addresses-found'
              t.text " #{emailCount}"

          if usernameCount
            t.div '.org-members-bulk-add-found-entry', ->
              t.format 'usernames-found'
              t.text " #{usernameCount}"

        if showBillingSummary
          price = if count then model.calculateTotalPrice(count) else 0

          if model.isPremiumMonthly()
            subscriptionIntervalKey = 'monthly-subscription'
          if model.isPremiumYearly()
            subscriptionIntervalKey = 'yearly-subscription'

          salesTaxForSubscriberUrl = "#{model.urlRoot}/#{model.id}/paidAccount/salesTaxForSubscriber"
          t.createElement Summary, {
            addSelectedMembers: @addMembers
            price
            selectedMembersCount: count
            subscriptionIntervalKey
            salesTaxForSubscriberUrl
          }
        else
          t.button { class: t.classify('primary': true, 'full': true, 'disabled': !count), onClick: @addMembers }, ->
            t.format 'add'


// WEBPACK FOOTER //
// ./app/scripts/views/organization/bulk-add-org-members-view-react.coffee